import axios from '@/plugins/axios.js';

export default {
    'SlideDecks/AUTO_SAVE': {
        fields: ['title', 'description'],

        callback: async (store, mutation) => {
            const { item } = mutation.payload;

            if (!item.title || !item.id || item.title.length > 191) return;

            store.dispatch('AutoSave/setSaving', mutation);

            await axios.put(`/api/slide-decks/${item.reference_id}`, item);

            store.dispatch('AutoSave/setSaved', mutation);
        },
    },
};
